import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { CancelButton, FormButton } from "../../../../components/Botton";
import Loader from "../../../../components/Loader";
import useAddSubject from "./useAddSubject";
import { IAddSubject } from "../../Subject.props";

const AddSubject: React.FC = () => {
  const {
    formData,
    loading,
    languages,
    courses: allCourses,
    standard,
    handleChange,
    handleSubmit,
    handleCancel,
  } = useAddSubject();

  const {
    register,
    handleSubmit: useFormSubmit,
    formState: { errors },
  } = useForm<IAddSubject>();

  const [filteredCourses, setFilteredCourses] = useState(allCourses);

  // Filter courses based on the selected standard
  useEffect(() => {
    if (formData.standard) {
      setFilteredCourses(
        allCourses.filter((course) => course.standard === formData.standard)
      );
    } else {
      setFilteredCourses([]);
    }
  }, [formData.standard, allCourses]);

  const fields = [
    {
      label: "Language",
      name: "languageName",
      type: "select",
      options: languages,
      disabled:false
    },
    {
      label: "Education",
      name: "standard",
      type: "select",
      options: standard,
      disabled:false
    },
    {
      label: "Stream",
      name: "courseName",
      type: "select",
      options: filteredCourses,
      disabled:!formData.standard
    },
    { label: "Subject Name", name: "subject", type: "text" },
  ] as const;

  return (
    <div className="flex flex-col items-center w-full h-screen p-8">
      <div className="bg-white shadow-md rounded-lg pt-6 pb-6 w-full ">
        <div className="border-b-2 w-[100%]">
          <h1 className="text-3xl mb-2 text-gray-700 ml-5">Add Subject</h1>
        </div>
        {loading && <Loader />}
        <form onSubmit={useFormSubmit(handleSubmit)} className="space-y-6">
          <fieldset className="m-2 rounded border-opacity-60 bg-white">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 m-4">
              {fields.map((field) => (
                <div key={field.name}>
                  <label
                    className="block text-gray-700 text-base font-semibold mb-2"
                    htmlFor={field.name}
                  >
                    {field.label}:
                  </label>
                  {field.type === "select" ? (
                    <select
                      id={field.name}
                      {...register(field.name, { required: true })}
                      onChange={handleChange}
                      disabled={field.disabled}

                      className="appearance-none border rounded w-full py-2 px-3 text-gray-600 leading-tight focus:outline-none focus:shadow-outline"
                    >
                      <option value="">Select {field.label}</option>
                      {field.options.map((option) => (
                        <option key={option._id} value={option[field.name]}>
                          {option[field.name]}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <input
                      className="appearance-none border rounded w-full py-2 px-3 text-gray-600 leading-tight focus:outline-none focus:shadow-outline"
                      type={field.type}
                      id={field.name}
                      {...register(field.name, { required: true })}
                      value={formData[field.name]}
                      onChange={handleChange}
                    />
                  )}
                  {errors[field.name] && (
                    <span className="text-red-500 text-xs italic">
                      {field.label} field is required
                    </span>
                  )}
                </div>
              ))}
            </div>
          </fieldset>
          <div className="flex justify-start mt-6 ml-10">
            <FormButton className="py-2 px-4 rounded mr-4" type="submit">
              ADD
            </FormButton>
            <CancelButton
              className="py-2 px-4 rounded"
              onClick={handleCancel}
              type="button"
            >
              Cancel
            </CancelButton>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddSubject;
